import { format, isSameDay } from "date-fns";

const keysRawToCargoDetails = {
	length: "length",
	weight: "weight",
	loadingAddressCity: "loadingAddressCustomCity",
	loadingAddressCountry: "loadingAddressCountry",
	loadingAddressZip: "loadingAddressCustomPostalCode",
	loadingDate: "loadingDate",
	loadingTime: "loadingTime",
	unloadingAddressCity: "unloadingAddressCustomCity",
	unloadingAddressCountry: "unloadingAddressCountry",
	unloadingAddressZip: "unloadingAddressCustomPostalCode",
	unloadingDate: "unloadingDate",
	unloadingTime: "unloadingTime",
	customerPrice: "customerPrice",
	vehicleBodyId: "vehicleBodyId",
	vehicleTypeId: "vehicleTypeId",
	additionalRequirements: "additionalRequirements",
	isFull: "isFtl",
	isLTL: "isFtl",
};

export function compareRawAndAppendedData(raw, cargoDetails) {
	let changedFieldCounter = 0;

	const rawKeys = Object.keys(raw);

	for (const key of rawKeys) {
		// ignore id key
		if (key === "id") {
			continue;
		}

		const rawValue = raw[key];
		const cargoDetailsKey = keysRawToCargoDetails[key];
		const cargoDetailsValue = cargoDetails[cargoDetailsKey];

		if (key === "length") {
			const rawLength = parseFloat(rawValue);
			const cargoLength = parseFloat(cargoDetailsValue);
			if (rawLength !== cargoLength) {
				console.log("up length");
				changedFieldCounter++;
			}
		}

		if (key === "weight") {
			const rawWeight = parseFloat(rawValue);
			const cargoWeight = parseFloat(cargoDetailsValue);
			if (rawWeight !== cargoWeight) {
				console.log("up weight");
				changedFieldCounter++;
			}
		}

		if (key === "customerPrice") {
			const rawCustomerPrice = rawValue ? parseFloat(rawValue) : null;
			const cargoCustomerPrice = cargoDetailsValue
				? parseFloat(cargoDetailsValue)
				: null;

			if (rawCustomerPrice !== cargoCustomerPrice) {
				console.log("up price");
				changedFieldCounter++;
			}
		}

		if (key === "loadingAddressCity") {
			const rawLoadingAddressCity = rawValue ? rawValue : null;
			const cargoLoadingAddressCity =
				cargoDetails["loadingAddress"]?.address?.city || null;

			if (
				rawLoadingAddressCity !== cargoDetailsValue &&
				rawLoadingAddressCity !== cargoLoadingAddressCity
			) {
				console.log("up city");
				changedFieldCounter++;
			}
		}

		if (key === "loadingAddressCountry") {
			const rawLoadingAddressCountry = rawValue ? rawValue : null;
			const cargoLoadingAddressCountry =
				cargoDetails["loadingAddress"]?.address?.countryCode || null;

			if (
				rawLoadingAddressCountry !== cargoDetailsValue &&
				rawLoadingAddressCountry !== cargoLoadingAddressCountry
			) {
				console.log("up country");
				changedFieldCounter++;
			}
		}

		if (key === "loadingAddressZip") {
			const rawLoadingAddressZip = rawValue ? rawValue : null;
			const cargoLoadingAddressZip =
				cargoDetails["loadingAddress"]?.address?.postalCode || null;

			if (
				rawLoadingAddressZip !== cargoDetailsValue &&
				rawLoadingAddressZip !== cargoLoadingAddressZip
			) {
				console.log("up zip");
				changedFieldCounter++;
			}
		}

		if (key === "loadingDate") {
			const expectedDateType = rawValue.includes(":") ? "range" : "day";
			const usedDateType = cargoDetails["loadingDateType"];

			if (expectedDateType !== usedDateType) {
				console.log("up loadingDate (types)");
				changedFieldCounter++;
				continue;
			}

			if (expectedDateType === "range") {
				const rawLoadingDateRange = rawValue.split(":");
				const cargoLoadingDateRange = cargoDetails["loadingDateRange"];

				const isTheSameFirst = isSameDay(
					new Date(rawLoadingDateRange[0]),
					cargoLoadingDateRange[0]
				);

				const isTheSameSecond = isSameDay(
					new Date(rawLoadingDateRange[1]),
					cargoLoadingDateRange[1]
				);

				if (!isTheSameFirst || !isTheSameSecond) {
					console.log("up loadingDate (ranges)");
					changedFieldCounter++;
					continue;
				}
			}

			if (expectedDateType === "day") {
				const rawLoadingDate = rawValue ? new Date(rawValue) : null;
				const cargoLoadingDate = cargoDetailsValue
					? new Date(cargoDetailsValue)
					: null;

				const isTheSame = isSameDay(rawLoadingDate, cargoLoadingDate);

				if (!isTheSame) {
					console.log("up loadingDate (day)");
					changedFieldCounter++;
				}
			}
		}

		if (key === "loadingTime") {
			const rawLoadingTime = rawValue.split("-");
			const cargoStartTime = cargoDetails["loadingTimeStart"] || null;
			const parsedStartTime = cargoStartTime
				? format(cargoStartTime, "HH:mm")
				: null;
			const cargoEndTime = cargoDetails["loadingTimeEnd"] || null;
			const parsedEndTime = cargoEndTime ? format(cargoEndTime, "HH:mm") : null;

			if (rawLoadingTime[0] !== parsedStartTime) {
				console.log("up loadingTime (start)");
				changedFieldCounter++;
			}

			if (
				(rawLoadingTime[1] || parsedEndTime) &&
				rawLoadingTime[1] !== parsedEndTime
			) {
				console.log("up loadingTime (end)");
				changedFieldCounter++;
			}
		}

		if (key === "unloadingAddressCity") {
			const rawUnloadingAddressCity = rawValue ? rawValue : null;
			const cargoUnloadingAddressCity =
				cargoDetails["unloadingAddress"]?.address?.city || null;

			if (
				rawUnloadingAddressCity !== cargoDetailsValue &&
				rawUnloadingAddressCity !== cargoUnloadingAddressCity
			) {
				console.log("up un-city");
				changedFieldCounter++;
			}
		}

		if (key === "unloadingAddressCountry") {
			const rawUnloadingAddressCountry = rawValue ? rawValue : null;
			const cargoUnloadingAddressCountry =
				cargoDetails["unloadingAddress"]?.address?.countryCode || null;

			if (
				rawUnloadingAddressCountry !== cargoDetailsValue &&
				rawUnloadingAddressCountry !== cargoUnloadingAddressCountry
			) {
				console.log("up un-country");
				changedFieldCounter++;
			}
		}

		if (key === "unloadingAddressZip") {
			const rawUnloadingAddressZip = rawValue ? rawValue : null;
			const cargoUnloadingAddressZip =
				cargoDetails["unloadingAddress"]?.address?.postalCode || null;

			if (
				rawUnloadingAddressZip !== cargoDetailsValue &&
				rawUnloadingAddressZip !== cargoUnloadingAddressZip
			) {
				console.log("up un-zip");
				changedFieldCounter++;
			}
		}

		if (key === "unloadingDate") {
			const expectedDateType = rawValue.includes(":") ? "range" : "day";
			const usedDateType = cargoDetails["unloadingDateType"];

			if (expectedDateType !== usedDateType) {
				console.log("up unloadingDate (types)");
				changedFieldCounter++;
				continue;
			}

			if (expectedDateType === "range") {
				const rawUnloadingDateRange = rawValue.split(":");
				const cargoUnloadingDateRange = cargoDetails["unloadingDateRange"];

				const isTheSameFirst = isSameDay(
					new Date(rawUnloadingDateRange[0]),
					cargoUnloadingDateRange[0]
				);

				const isTheSameSecond = isSameDay(
					new Date(rawUnloadingDateRange[1]),
					cargoUnloadingDateRange[1]
				);

				if (!isTheSameFirst || !isTheSameSecond) {
					console.log("up unloadingDate (ranges)");
					changedFieldCounter++;
					continue;
				}
			}

			if (expectedDateType === "day") {
				const rawUnloadingDate = rawValue ? new Date(rawValue) : null;
				const cargoUnloadingDate = cargoDetailsValue
					? new Date(cargoDetailsValue)
					: null;

				const isTheSame = isSameDay(rawUnloadingDate, cargoUnloadingDate);

				if (!isTheSame) {
					console.log("up unloadingDate (day)");
					changedFieldCounter++;
				}
			}
		}

		if (key === "unloadingTime") {
			const rawUnloadingTime = rawValue.split("-");
			const cargoStartTime = cargoDetails["unloadingTimeStart"] || null;
			const parsedStartTime = cargoStartTime
				? format(cargoStartTime, "HH:mm")
				: null;
			const cargoEndTime = cargoDetails["unloadingTimeEnd"] || null;
			const parsedEndTime = cargoEndTime ? format(cargoEndTime, "HH:mm") : null;

			if (rawUnloadingTime[0] !== parsedStartTime) {
				console.log("up unloadingTime (start)");
				changedFieldCounter++;
			}

			if (
				(rawUnloadingTime[1] || parsedEndTime) &&
				rawUnloadingTime[1] !== parsedEndTime
			) {
				console.log("up unloadingTime (end)");
				changedFieldCounter++;
			}
		}

		if (key === "vehicleBodyId") {
			const compareResult = areArraysEqualUnordered(
				rawValue,
				cargoDetailsValue
			);

			if (!compareResult) {
				console.log("up vehicleBodyId");
				changedFieldCounter++;
			}
		}
		if (key === "vehicleTypeId") {
			const compareResult = areArraysEqualUnordered(
				rawValue,
				cargoDetailsValue
			);

			if (!compareResult) {
				console.log("up vehicleTypeId");
				changedFieldCounter++;
			}
		}
		if (key === "additionalRequirements") {
			const compareResult = areArraysEqualUnordered(
				rawValue,
				cargoDetailsValue
			);

			if (!compareResult) {
				console.log("up additionalRequirements");
				changedFieldCounter++;
			}
		}
		if (key === "isFull") {
			// cargoDetailsValue - "isFtl": "false"/"true"
			const isCargoDetailsFTL = cargoDetailsValue === "false" ? false : true;
			if (rawValue && !isCargoDetailsFTL) {
				console.log("up isFull");
				changedFieldCounter++;
			}
		}
		if (key === "isLTL") {
			// cargoDetailsValue - "isFtl": "false"/"true"
			const isCargoDetailsLTL = cargoDetailsValue === "false" ? true : false;
			if (rawValue && !isCargoDetailsLTL) {
				console.log("up isLTL");
				changedFieldCounter++;
			}
		}
	}

	return changedFieldCounter;
}

export const areArraysEqualUnordered = (a, b) =>
	a.length === b.length &&
	[...a].sort().every((val, index) => val === [...b].sort()[index]);
